import { AssignedToFilter } from './AssignedToFilter';
import { InitiativeStatusDisplay } from '../InitiativeStatusDisplay';
import React from 'react';
import { SonarText } from '@ui/text';
import { UserNameDisplay } from '@ui/general';
import { FilterOutlined, SearchOutlined } from '@ant-design/icons';
import { InitiativeStatus } from '@sonar-software/sonar-core';
import { INITIATIVES_STATUS, INITIATIVES_TABLE_DATA_INDICES, INITIATIVES_TABLE_KEYS, INITIATIVES_TABLE_LABELS } from '@sonar-software/sonar-ts-constants';
export const initiativeTitleColumn = {
    dataIndex: INITIATIVES_TABLE_DATA_INDICES.TITLE,
    key: INITIATIVES_TABLE_KEYS.TITLE,
    render: (value) => React.createElement(SonarText, { link: true }, value),
    sortDirections: ['ascend', 'descend', 'ascend'],
    sorter: true,
    title: INITIATIVES_TABLE_LABELS.TITLE
};
const statusFilters = [
    {
        text: INITIATIVES_STATUS.NEW,
        value: InitiativeStatus.New
    },
    {
        text: INITIATIVES_STATUS.READY,
        value: InitiativeStatus.Ready
    },
    {
        text: INITIATIVES_STATUS.IN_PROGRESS,
        value: InitiativeStatus.InProgress
    },
    {
        text: INITIATIVES_STATUS.TESTING,
        value: InitiativeStatus.Testing
    },
    {
        text: INITIATIVES_STATUS.FINISHED,
        value: InitiativeStatus.Finished
    }
];
export const initiativeStatusColumn = {
    dataIndex: INITIATIVES_TABLE_DATA_INDICES.STATUS_ID,
    filterIcon: React.createElement(FilterOutlined, null),
    filters: statusFilters,
    key: INITIATIVES_TABLE_KEYS.STATUS,
    render: (value) => React.createElement(InitiativeStatusDisplay, { statusId: Number(value) }),
    title: INITIATIVES_TABLE_LABELS.STATUS
};
export const initiativeAssignedToColumn = {
    dataIndex: INITIATIVES_TABLE_DATA_INDICES.ASSIGNED_TO,
    filterDropdown: (props) => React.createElement(AssignedToFilter, Object.assign({}, props)),
    filterDropdownProps: { destroyOnHidden: true },
    filterIcon: React.createElement(SearchOutlined, null),
    key: INITIATIVES_TABLE_KEYS.ASSIGNED_TO,
    render: (value, initiative) => { var _a; return React.createElement(UserNameDisplay, { userId: (_a = initiative.assignedTo) !== null && _a !== void 0 ? _a : 0 }); },
    title: INITIATIVES_TABLE_LABELS.ASSIGNED_TO
};
export const initiativeCreatedOnColumn = {
    dataIndex: INITIATIVES_TABLE_DATA_INDICES.CREATED_ON,
    defaultSortOrder: 'descend',
    key: INITIATIVES_TABLE_KEYS.CREATED_ON,
    render: (value) => new Date(value).toLocaleDateString(),
    sortDirections: ['ascend', 'descend', 'ascend'],
    sorter: true,
    title: INITIATIVES_TABLE_LABELS.CREATED_ON
};
export function getInitiativeTableColumns() {
    return [initiativeTitleColumn, initiativeStatusColumn, initiativeAssignedToColumn, initiativeCreatedOnColumn];
}
